module.exports = __webpack_public_path__ + "static/media/kpg-accountants-banner1.8d6a8163.jpg";